import { createEffect, sample } from 'effector';
import $$api from 'models/api';

sample({
    clock: [$$api.guide.getFirstAvailableArticleFx.failData],
    target: createEffect(console.log),
});
